export default __webpack_public_path__ + "static/media/IconSportToto.5140ff86.png";